export default __webpack_public_path__ + "static/media/GH.6c561827.svg";